import axios from 'axios'
import { AzSearchUrlBuilder } from '@azinformatica/loki'

class FundoEspecialApiClient {
    async buscarFundos(orgaoId) {
        const url = AzSearchUrlBuilder.build(`api/unidadesOrganizacionais/${orgaoId}/fundos`)
        return axios.get(url)
    }
}

export default new FundoEspecialApiClient()
